import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { NotificationChannelsList } from '../components/NotificationChannelsList';
import { NotificationChannel } from '../types';

interface NotificationsTabProps {
  channels: NotificationChannel[];
  loading: boolean;
  onAddChannel: () => void;
  onEditChannel: (channel: NotificationChannel) => void;
  onDeleteChannel: (channel: NotificationChannel) => void;
  onTestChannel: (id: number) => Promise<{ success: boolean; message: string; deliveryTime?: number }>;
  onChannelVerified: (id: number) => void;
}

const TableSkeleton = () => (
  <Box>
    {[1, 2, 3, 4, 5].map((i) => (
      <Skeleton
        key={i}
        variant="rectangular"
        height={60}
        sx={{ mb: 1, borderRadius: 1 }}
      />
    ))}
  </Box>
);

export function NotificationsTab({
  channels,
  loading,
  onAddChannel,
  onEditChannel,
  onDeleteChannel,
  onTestChannel,
  onChannelVerified,
}: NotificationsTabProps) {
  if (loading) {
    return <TableSkeleton />;
  }

  return (
    <NotificationChannelsList
      channels={channels}
      onAddChannel={onAddChannel}
      onEditChannel={onEditChannel}
      onDeleteChannel={onDeleteChannel}
      onTestChannel={onTestChannel}
      onChannelVerified={onChannelVerified}
    />
  );
}
